var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 71,
    viewBox: "0 0 82 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1641_58891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 71
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H81.3578V70.7459H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1641_58891)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74154 3.53711C3.63017 3.53711 3.53954 3.62775 3.53954 3.73911V67.0063C3.53954 67.1182 3.63017 67.2088 3.74154 67.2088H77.6207C77.7335 67.2088 77.8232 67.1182 77.8232 67.0063V3.73911C77.8232 3.62775 77.7335 3.53711 77.6207 3.53711H3.74154ZM77.6203 70.746H3.74111C1.67917 70.746 0.00195312 69.0693 0.00195312 67.0064V3.73915C0.00195312 1.67722 1.67917 0 3.74111 0H77.6203C79.6827 0 81.3599 1.67722 81.3599 3.73915V67.0064C81.3599 69.0693 79.6827 70.746 77.6203 70.746Z",
    fill: "#512DA7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1641_58891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 82,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6118H81.3578V14.149H0V10.6118Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1641_58891)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5891 14.149H1.76834C0.791605 14.149 0 13.3569 0 12.3806C0 11.4034 0.791605 10.6118 1.76834 10.6118H79.5891C80.5668 10.6118 81.3579 11.4034 81.3579 12.3806C81.3579 13.3569 80.5668 14.149 79.5891 14.149Z",
    fill: "#512DA7"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5969 49.522H24.761C23.7843 49.522 22.9922 48.7299 22.9922 47.7532C22.9922 46.7765 23.7843 45.9844 24.761 45.9844H56.5969C57.5745 45.9844 58.3657 46.7765 58.3657 47.7532C58.3657 48.7299 57.5745 49.522 56.5969 49.522Z",
    fill: "#4086FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6809 53.0592C39.7042 53.0592 38.9121 52.2671 38.9121 51.2904V44.2893C38.9121 43.3126 39.7042 42.521 40.6809 42.521C41.6572 42.521 42.4493 43.3126 42.4493 44.2893V51.2904C42.4493 52.2671 41.6572 53.0592 40.6809 53.0592Z",
    fill: "#4086FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0616 60.1352C52.3226 60.1352 51.6346 59.6686 51.3859 58.9305L42.5702 32.7704C42.3456 32.106 42.536 31.3728 43.0523 30.8994C43.8039 30.2133 44.218 29.2891 44.218 28.2984C44.218 26.3479 42.631 24.7613 40.6809 24.7613C38.7298 24.7613 37.1437 26.3479 37.1437 28.2984C37.1437 29.2891 37.5574 30.2133 38.3094 30.8994C38.8267 31.3728 39.0157 32.106 38.792 32.7704L29.9764 58.9305C29.664 59.8561 28.6588 60.3493 27.7356 60.0422C26.8099 59.7298 26.3124 58.7266 26.6243 57.8004L35.1073 32.6286C34.1427 31.3925 33.6066 29.8667 33.6066 28.2984C33.6066 24.3978 36.7802 21.2241 40.6809 21.2241C44.5825 21.2241 47.7557 24.3978 47.7557 28.2984C47.7557 29.8667 47.2186 31.3925 46.2549 32.6286L54.7369 57.8004C55.0493 58.7266 54.5523 59.7298 53.6262 60.0422C53.4396 60.1049 53.2482 60.1352 53.0616 60.1352Z",
    fill: "#4086FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1641_58891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 71
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 70.746H81.3579V0H0V70.746Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1641_58891)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07617 8.84282H10.6133V5.30566H7.07617V8.84282Z",
    fill: "#512DA7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1504 8.84282H17.6875V5.30566H14.1504V8.84282Z",
    fill: "#512DA7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowCompass);
export default __webpack_public_path__ + "static/media/BowCompass.617f1e51caf2b1839774cd35f9db037f.svg";
export { ForwardRef as ReactComponent };